import PropTypes from 'prop-types';
import { skiplinksThemes } from 'config/branding/component-themes/skiplinks-themes';
import headerHeights from 'config/branding/header-heights';
import SkiplinksMenu from '@activebrands/core-web/components/SkiplinksMenu';
import { styled } from '@activebrands/core-web/libs/styletron';
import { LayoutProps } from '@activebrands/core-web/types/layout';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Banner from 'components/Header/Banner';
import { getHeaderTheme } from 'components/Header/getHeaderTheme';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100svh',
});

const Main = styled('main', {
    flex: '1 0 auto',
    scrollMarginTop: 'var(--height-header)',
});

const DefaultLayout = ({ children, page = {} }: LayoutProps) => {
    const alternateHrefs = page.data?.hrefs || [];
    const transparentHeader = page.data?.content?.transparentHeader;
    const pageContent = page.data?.content || {};
    const theme = getHeaderTheme({
        heroTextColor: pageContent.heroContent?.[0]?.textColor,
        transparent: transparentHeader,
    });
    const { bannerHeight, headerHeight } = headerHeights;
    const banner = pageContent.banner?.[0] || {};
    const bannerTexts = banner?.texts?.map(text => text?.richText || text);
    const hasBanner = bannerTexts?.length > 0;
    const dynamicBannerHeight = hasBanner ? bannerHeight : 0;

    // Let content of the noPageType fall behind the header in desktop
    const contentTopOfPage = ['noPageType'].includes(page.type);

    // Calculate the distance from the top of the page for content
    const contentOffset = `${contentTopOfPage ? 0 : headerHeight + dynamicBannerHeight}px`;

    return (
        <Wrapper $style={{ paddingTop: contentOffset }}>
            <SkiplinksMenu
                fontKeys="Misc/16_100_-02"
                $style={skiplinksThemes.default.menu}
                linkStyle={skiplinksThemes.default.link}
            />
            <Header alternateHrefs={alternateHrefs} theme={theme} />
            {hasBanner && (
                <Banner spin={banner?.spin} texts={bannerTexts} theme={banner.theme} to={banner?.link?.url} />
            )}
            <Main id="main" role="main" tabIndex={-1}>
                {children}
            </Main>
            <Footer alternateHrefs={alternateHrefs} />
        </Wrapper>
    );
};

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    page: PropTypes.object.isRequired,
};

export default DefaultLayout;
